import styled from 'styled-components'
import { Container } from '../../styles/Wrappers'
import { device } from '../../styles/Breakpoints'

export const TabsAndContentContainer = styled(Container)`
	display: none;

	@media ${device.sm} {
		display: grid;
		grid-template-rows: ${(props) => (props.hasTitle ? '100px auto' : 'auto')};
		grid-template-columns: 1fr 3fr;

		h2 {
			grid-column: 1 / span 2;
			justify-items: start;
		}
	}
`

export const TabLabels = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	width: 100%;
`

export const TabContentBlock = styled.div`
	width: 100%;
	display: block;
	position: relative;
	overflow: hidden;
	padding-top: calc(${(props) => props.height} / ${(props) => props.width} * 100%);

	img {
		width: 100%;
	}
`

export const TabContentPanel = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	opacity: ${(props) => (props.active ? 1 : 0)};
	/* transition: opacity 0.5s ease-in-out; */
	visibility: visible;
	transition: visibility 0s, opacity 0.5s linear;
	/* ${(props) => (props.active ? 'display: flex;' : 'display:none;')}; */
`

export const TabLabel = styled.button`
	display: flex;
	flex-direction: column;
	border-radius: 5px;
	${(props) => (props.active ? 'background-color: var(--green);' : 'background-color: var(--grey-44);')}
	${(props) => (props.active ? 'color: #fff;' : 'color: var(--dark-grey);')}

    transition: background-color 0.3s ease-in-out;
	transition: box-shadow 0.3s ease-in-out;

	width: 250px;
	padding: 10px 20px;
	border: 0;

	margin-bottom: 20px;

	&:hover {
		${(props) => (props.active ? 'background-color: var(--green);' : 'background-color: #fff;')}
		box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
	}

	h3 {
		margin-bottom: 10px;
		text-align: left;
	}

	p {
		margin: 0;
		text-align: left;
	}
`
